<template>
  <th>
    <slot />
    <i
      :class="{ 'material-icons': true, 'is-desc': true, 'is-active': column === field && direction === 'DESC', 'ml-2': true }"
      @click="setOrdering(field, 'DESC')">
      filter_list
    </i>
    <i
      :class="{ 'material-icons': true, 'is-asc': true, 'is-active': column === field && direction === 'ASC', 'ml-1': true }"
      @click="setOrdering(field, 'ASC')">
      filter_list
    </i>
  </th>
</template>

<script>
export default {
  name: 'sortable-table-heading',
  props: [
    'field',
    'view',
    'column',
    'direction'
  ],
  methods: {
    setOrdering (field, direction) {
      // Sprawdź aktualny stan z localStorage (najbardziej aktualne wartości)
      const currentColumn = window.localStorage.getItem('crm-ordering-' + this.view + '-column');
      const currentDirection = window.localStorage.getItem('crm-ordering-' + this.view + '-direction');
      
      // Jeśli kliknięto w aktywny przycisk, zmień kierunek sortowania na przeciwny
      let newDirection = direction;
      if (currentColumn === field && currentDirection === direction) {
        newDirection = direction === 'ASC' ? 'DESC' : 'ASC';
      }
      
      window.localStorage.setItem('crm-ordering-' + this.view + '-column', field);
      window.localStorage.setItem('crm-ordering-' + this.view + '-direction', newDirection);
      this.$bus.emit('table-ordering-change', { column: field, direction: newDirection });
    }
  }
}
</script>

<style lang="scss" scoped>
.is-desc,
.is-asc {
  color: var(--white);
  cursor: pointer;
  opacity: .5;
  transform: scale(1.2);

  &.is-active {
    color: var(--white);
    opacity: 1;
  }
}

.is-asc {
  transform: scale(1.2) rotate(180deg);
}
</style>
